'use client';

import clsx from 'clsx';

import { Alter25QADropDowns } from '@/components/alter25/Alter25QADropDowns';
import { everythingYouNeedToKnow } from '@/data/shop/swab-kit/need-to-know.data';

export const SwabKitProductDetailsNeedToKnow: React.FC = () => {
  return (
    <div className="mb-8">
      <div
        className={clsx(
          'mb-6 font-light',
          'text-xl leading-[30px] tracking-[-.6px]',
          'md:text-xl md:leading-[24px] md:tracking-[-.6px]'
        )}
      >
        Everything You Need to Know
      </div>
      <Alter25QADropDowns qas={everythingYouNeedToKnow} noPreopen />
    </div>
  );
};
